// core/wa — helper WhatsApp TERPUSAT.
// DEV (npm run dev / testing) → halaman DUMMY (/wa-dummy.html) — TIDAK PERNAH ke WhatsApp asli.
// PRODUCTION (vite build) → wa.me (manual, dibuka user sungguhan).
// Batasan Apo: uji WA WAJIB lewat dummy; jangan sentuh WhatsApp app / WhatsApp Web saat testing.
const DUMMY = import.meta.env.DEV;

/** URL tujuan WA (dummy saat dev, wa.me saat production). `number` boleh berformat apa pun (di-strip ke digit). */
export function waUrl(number: string | null | undefined, text = ''): string {
  const n = (number ?? '').replace(/\D/g, '');
  return DUMMY
    ? `/wa-dummy.html?to=${encodeURIComponent(n)}&text=${encodeURIComponent(text)}`
    : `https://wa.me/${n}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}

/** Buka WA (tab baru). Dev = jendela dummy kecil; production = wa.me. */
export function openWA(number: string | null | undefined, text = ''): void {
  window.open(waUrl(number, text), '_blank', DUMMY ? 'width=420,height=680' : '');
}
